import React from 'react';
import { ContainerPrivacyPolicyCheckbox } from './styled';
const PrivacyPolicyCheckbox = ({
  text,
  checked,
  setValue,
  userData,
  validate,
}) => {
  function handleClick(e) {
    setValue({ ...userData, PrivacyPolicy: e.currentTarget.checked });
    validate(e);
  }
  return (
    <ContainerPrivacyPolicyCheckbox>
      <input
        checked={checked}
        id='PrivacyPolicy'
        type='checkbox'
        onChange={handleClick}
        value={!checked}
      />
      <div>{text}</div>
    </ContainerPrivacyPolicyCheckbox>
  );
};

export default PrivacyPolicyCheckbox;
